/**
 * Toast 提示
 */
export function useToastHandler() {
  const toast = useToast()

  /**
   * 显示成功提示
   * @param message - 成功消息
   */
  const showSuccessToast = (message: string) => {
    toast.add({
      title: message,
      icon: 'mingcute:check-fill',
      color: 'neutral',
      orientation: 'horizontal',
      duration: 3000,
      class: 'w-auto !bg-[#131318] border-[1px] border-solid border-[#131318] py-[8px] px-[16px] ring-none shadow-[0px_4px_16px_0px_#000000B2]',
      ui: {
        icon: 'size-[24px] text-[#27C840]',
        title: 'font-["Roboto"] text-[16px] text-white leading-[20px]',
        description: 'hidden',
        actions: 'hidden',
        close: 'hidden',
        progress: 'hidden'
      }
    })
  }

  /**
   * 显示错误提示
   * @param message - 错误消息
   */
  const showErrorToast = (message: string) => {
    toast.add({
      title: message,
      description: 'message',
      icon: 'mingcute:close-fill',
      color: 'neutral',
      orientation: 'horizontal',
      duration: 3000,
      ui: {
        root: 'w-auto !bg-[#131318] border-[1px] border-solid border-[#131318] py-[8px] px-[16px] ring-none shadow-[0px_4px_16px_0px_#000000B2]',
        wrapper: '',
        icon: 'size-[24px] text-[#FF5F57]',
        title: 'font-["Roboto"] text-[16px] text-white leading-[20px]',
        description: 'hidden',
        actions: 'hidden',
        close: 'hidden',
        progress: 'hidden'
      }
    })
  }

  return {
    showSuccessToast,
    showErrorToast
  }
}
